import type { CatalogScope } from "../api/catalogScope";
import { useGetChainQuery } from "../query/chainsQuery";
import { useGetStoreQuery } from "../query/storesQuery";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const useShowCatalogOriginMarkers = (scope: CatalogScope | null) => {
  const storeId = scope?.type === "store" ? scope.id : undefined;
  const chainIdFromScope: ChainId | undefined =
    scope?.type === "chain" ? scope.id : undefined;
  const { data: store } = useGetStoreQuery(storeId);
  const chainId = chainIdFromScope ?? store?.chainId;
  const { data: chain } = useGetChainQuery(chainId);

  return chain?.chainMode === true;
};
